import App from "@/App";
import Router from "@/constants/router";
import {
  Admins,
  AiManager,
  BulkEmail,
  CompanyStamp,
  Dashboard,
  InstallmentSetting,
  Layout,
  Login,
  Subscription,
  SuperChatContent,
  SuperChatLog,
  PromptTemplate,
  BossBabyChatLog,
  BossBabyPromptTemplate,
  BossBaby,
  OciAiTest,
  Template,
} from "@/pages";
import { createBrowserRouter } from "react-router-dom";

const router = createBrowserRouter([
  {
    path: Router.Dashboard,
    element: <App />,
    children: [
      ////////// 로그인 //////////
      {
        path: Router.Login,
        element: <Login />,
      },
      {
        path: Router.Dashboard,
        element: <Layout />,
        children: [
          ////////// 대시보드 //////////
          {
            path: Router.Dashboard,
            element: <Dashboard />,
          },
          ////////// 관리자 관리 //////////
          {
            path: Router.Admins,
            element: <Admins.List />,
          },
          {
            path: Router.AdminsCreate,
            element: <Admins.Create />,
          },
          {
            path: Router.AdminsDetail,
            element: <Admins.Detail />,
          },

          ////////// 도장 관리 //////////
          {
            path: Router.CompanyStamp,
            element: <CompanyStamp.List />,
          },
          {
            path: Router.CompanyStampDetail,
            element: <CompanyStamp.Detail />,
          },
          ////////// 구독 상품 관리 //////////
          {
            path: Router.Subscription,
            element: <Subscription.List />,
          },
          {
            path: Router.SubscriptionCreate,
            element: <Subscription.Create />,
          },
          {
            path: Router.SubscriptionDetail,
            element: <Subscription.Detail />,
          },
          ////////// 템플릿 관리 //////////
          {
            path: Router.Template,
            element: <Template.List />,
          },
          {
            path: Router.TemplateCreate,
            element: <Template.Create />,
          },
          {
            path: Router.TemplateDetail,
            element: <Template.Detail />,
          },
          ////////// 분할결제 설정 관리 //////////
          {
            path: Router.InstallmentSetting,
            element: <InstallmentSetting.List />,
          },
          {
            path: Router.InstallmentSettingCreate,
            element: <InstallmentSetting.Create />,
          },
          {
            path: Router.InstallmentSettingDetail,
            element: <InstallmentSetting.Create />,
          },
          ////////// 이메일 대량 발송 관리 //////////
          {
            path: Router.BulkEmail,
            element: <BulkEmail.List />,
          },

          ////////// QNA 챗봇 컨텐츠 관리 //////////
          {
            path: Router.SuperChatContent,
            element: <SuperChatContent.List />,
          },
          {
            path: Router.SuperChatContentDetail,
            element: <SuperChatContent.Detail />,
          },
          {
            path: Router.SuperChatContentCreateContent,
            element: <SuperChatContent.CreateContent />,
          },
          {
            path: Router.SuperChatContentCreatePrompt,
            element: <SuperChatContent.CreatePrompt />,
          },
          {
            path: Router.SuperChatPromptDetail,
            element: <SuperChatContent.PromptDetail />,
          },

          ////////// QNA 챗봇 로그 관리 //////////
          {
            path: Router.SuperChatLogDashboard,
            element: <SuperChatLog.Dashboard />,
          },
          {
            path: Router.SuperChatLogSessions,
            element: <SuperChatLog.Sessions />,
          },
          {
            path: Router.SuperChatLogSessionDetail,
            element: <SuperChatLog.SessionDetail />,
          },

          ////////// Prompt Template Management //////////
          {
            path: Router.PromptTemplate,
            element: <PromptTemplate.List />,
          },
          {
            path: Router.PromptTemplateCreate,
            element: <PromptTemplate.Create />,
          },
          {
            path: Router.PromptTemplateDetail,
            element: <PromptTemplate.Detail />,
          },

          ////////// Boss Baby Chat Log //////////
          {
            path: Router.BossBabyChatLogSessions,
            element: <BossBabyChatLog.SessionList />,
          },
          {
            path: Router.BossBabyChatLogSessionDetail,
            element: <BossBabyChatLog.SessionDetail />,
          },

          ////////// Boss Baby Prompt Template //////////
          {
            path: Router.BossBabyPromptTemplate,
            element: <BossBabyPromptTemplate.List />,
          },
          {
            path: Router.BossBabyPromptTemplateCreate,
            element: <BossBabyPromptTemplate.Create />,
          },
          {
            path: Router.BossBabyPromptTemplateDetail,
            element: <BossBabyPromptTemplate.Detail />,
          },

          ////////// Boss Baby Tool Management //////////
          {
            path: Router.BossBabyToolList,
            element: <BossBaby.ToolList />,
          },
          {
            path: Router.BossBabyToolCreate,
            element: <BossBaby.ToolCreate />,
          },
          {
            path: Router.BossBabyToolEdit,
            element: <BossBaby.ToolEdit />,
          },

          ////////// Boss Baby Task Management //////////
          {
            path: Router.BossBabyTaskList,
            element: <BossBaby.TaskList />,
          },
          {
            path: Router.BossBabyTaskCreate,
            element: <BossBaby.TaskCreate />,
          },
          {
            path: Router.BossBabyTaskEdit,
            element: <BossBaby.TaskEdit />,
          },

          ////////// Boss Baby Company Settings //////////
          {
            path: Router.BossBabyCompanySettings,
            element: <BossBaby.CompanySettings />,
          },

          ////////// OCI AI Test //////////
          {
            path: Router.OciAiTestChat,
            element: <OciAiTest.Chat />,
          },
          {
            path: Router.OciAiTestCompare,
            element: <OciAiTest.Compare />,
          },
          {
            path: Router.OciAiTestTranslate,
            element: <OciAiTest.Translate />,
          },
          {
            path: Router.OciAiTestModels,
            element: <OciAiTest.Models />,
          },
          ////////// AI Manager 관리 //////////
          {
            path: Router.AiManager,
            element: <AiManager.Dashboard />,
          },
        ],
      },
    ],
  },
]);

export default router;
